import React from 'react'

function Appraisals() {
    return (
        <div>
            <h1>Layout add will soon</h1>
        </div>
    )
}

export default Appraisals 
